import React, {  useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { RotatingSquare } from "react-loader-spinner";
import UserInformation from "./UserInformation";
import AgentAccount from "./AgentAccount/AgentAccount";
import Sponsors from "./Sponsors/Sponsors";
import OrderSetAssign from "./OrderSetAssign/OrderSetAssign";
import UserOrderList from "../UserOrderList/UserOrderList";

const UserDetails = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const [userUpdateData, setuserUpdateData] = useState({});

  useEffect(() => {
    fetch(`https://api.velormall.com/api/admin/user/view/single/${id}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setUserData(data.data);
      });
  }, [userUpdateData]);

  const [data, setData] = useState([]);
  useEffect(() => {
    fetch(`https://api.velormall.com/api/admin/user/view/history/view/${id}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data);
        setLoading(false);
      });
  }, []);

  const refSubmitDis = useRef();
  // Balance Add

  const [BalanceAddModalshow, setBalanceAddModalShow] = useState(false);
  const handleBalanceAddModalClose = () => setBalanceAddModalShow(false);
  const handleBalanceAddModalShow = () => setBalanceAddModalShow(true);

  // view data
  const [BalanceAddDataVulue, setBalanceAddDataVulue] = useState({});

  // store data

  const handleSubmitData = (event) => {
    event.preventDefault();
    const storeData = { ...BalanceAddDataVulue, user_id: id };
    refSubmitDis.current.setAttribute("disabled", true);
    fetch(`https://api.velormall.com/api/admin/user/view/balance/add`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(storeData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success === false) {
          toast.error(`${data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          refSubmitDis.current.removeAttribute("disabled");
        } else {
          handleBalanceAddModalClose();
          toast.success(`${data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          event.target.reset();
          refSubmitDis.current.removeAttribute("disabled");
        }
      })
      .catch((error) => refSubmitDis.current.removeAttribute("disabled"));
  };

  const handleBalanceAddInputBlur = (event) => {
    const value = event.target.value;
    const field = event.target.name;
    const newData = { ...BalanceAddDataVulue };
    newData[field] = value;
    setBalanceAddDataVulue(newData);
  };

  // Balance Minus

  const [BalanceMinusModalshow, setBalanceMinusModalShow] = useState(false);
  const handleBalanceMinusModalClose = () => setBalanceMinusModalShow(false);
  const handleBalanceMinusModalShow = () => setBalanceMinusModalShow(true);

  // view data
  const [BalanceMinusDataVulue, setBalanceMinusDataVulue] = useState({});

  // store data

  const handleBalanceMinusSubmitData = (event) => {
    event.preventDefault();
    const storeData = { ...BalanceMinusDataVulue, user_id: id };
    refSubmitDis.current.setAttribute("disabled", true);
    fetch(`https://api.velormall.com/api/admin/user/view/balance/subtract`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(storeData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success === false) {
          toast.error(`${data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          refSubmitDis.current.removeAttribute("disabled");
        } else {
          handleBalanceMinusModalClose();
          toast.error(`${data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          event.target.reset();
          refSubmitDis.current.removeAttribute("disabled");
        }
      })
      .catch((error) => refSubmitDis.current.removeAttribute("disabled"));
  };

  const handleBalanceMinusInputBlur = (event) => {
    const value = event.target.value;
    const field = event.target.name;
    const newData = { ...BalanceMinusDataVulue };
    newData[field] = value;
    setBalanceMinusDataVulue(newData);
  };




  // banned user

  const [BannedModalshow, setBannedModalShow] = useState(false);
  const handleBannedModalClose = () => setBannedModalShow(false);
  const handleBannedModalShow = () => setBannedModalShow(true);

  // view data
  const [BanDataVulue, setBanDataVulue] = useState({});

  // store data

  const handleBanSubmitData = (event) => {
    event.preventDefault();
    refSubmitDis.current.setAttribute("disabled", true);
    fetch(`https://api.velormall.com/api/admin/user/view/banned/${id}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(BanDataVulue),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success === false) {
          toast.error(`${data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          refSubmitDis.current.removeAttribute("disabled");
        } else {
          handleBannedModalClose();
          toast.error(`${data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setuserUpdateData(data?.data);
          event.target.reset();
          refSubmitDis.current.removeAttribute("disabled");
        }
      })
      .catch((error) => refSubmitDis.current.removeAttribute("disabled"));
  };

  const handleUnBanSubmitData = (event) => {
    event.preventDefault();
    refSubmitDis.current.setAttribute("disabled", true);
    fetch(`https://api.velormall.com/api/admin/user/view/banned/${id}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        toast.success(`${data.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setuserUpdateData(data?.data);
        refSubmitDis.current.removeAttribute("disabled");
      })
      .catch((error) => refSubmitDis.current.removeAttribute("disabled"));
  };

  const handleUserBanInputBlur = (event) => {
    const value = event.target.value;
    const field = event.target.name;
    const newData = { ...BanDataVulue };
    newData[field] = value;
    setBanDataVulue(newData);
  };

  const UserTradeUserTrade = useRef();

  const handleUserTrade = (event) => {
    event.preventDefault();
    UserTradeUserTrade.current.setAttribute("disabled", true);
    const formData = new FormData(event.currentTarget);
    const InpuData = Object.fromEntries(formData);
    fetch(`https://api.velormall.com/api/admin/user/view/trade/update/${id}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(InpuData),
    })
      .then((res) => res.json())
      .then((data) => {
        toast.success(`${data.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        UserTradeUserTrade.current.removeAttribute("disabled");
      })
      .catch((error) => {
        // console.log(error)
      });
  };

  if (loading) {
    return (
      <>
        <div className="loader-css">
          <RotatingSquare
            visible={true}
            height="100"
            width="100"
            color="#4fa94d"
            ariaLabel="rotating-square-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      </>
    );
  }
  return (
    <>
      <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
        <h6 className="page-title">
          User Detail - {userData?.username}
        </h6>
        <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins"></div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="row gy-4">
            <div className="col-xxl-3 col-sm-6">
              <div className="widget-two style--two box--shadow2 b-radius--5 bg--19">
                <div className="widget-two__icon b-radius--5 bg--primary">
                  <i className="las la-money-bill-wave-alt"></i>
                </div>
                <div className="widget-two__content">
                  <h3 className="text-white">${userData?.balance}</h3>
                  <p className="text-white">Balance</p>
                </div>
                <Link
                  to={`/admin/report/transaction/history/${userData?._id}`}
                  className="widget-two__btn"
                >
                  View All
                </Link>
              </div>
            </div>
            <div className="col-xxl-3 col-sm-6">
              <div className="widget-two style--two box--shadow2 b-radius--5 bg--primary">
                <div className="widget-two__icon b-radius--5 bg--primary">
                  <i className="las la-wallet"></i>
                </div>
                <div className="widget-two__content">
                  <h3 className="text-white">
                    ${data?.DepositAcceptBalanceSum}
                  </h3>
                  <p className="text-white">Deposits</p>
                </div>
                <Link
                  to={`/admin/deposit/history/${userData?._id}`}
                  className="widget-two__btn"
                  alt=""
                >
                  View All
                </Link>
              </div>
            </div>
            <div className="col-xxl-3 col-sm-6">
              <div className="widget-two style--two box--shadow2 b-radius--5 bg--1">
                <div className="widget-two__icon b-radius--5 bg--primary">
                  <i className="fas fa-wallet"></i>
                </div>
                <div className="widget-two__content">
                  <h3 className="text-white">
                    ${data?.WithdrawalAcceptBalanceSum}
                  </h3>
                  <p className="text-white">Withdrawals</p>
                </div>
                <Link
                  to={`/admin/withdraw/history/${userData?._id}`}
                  className="widget-two__btn"
                  alt=""
                >
                  View All
                </Link>
              </div>
            </div>
            <div className="col-xxl-3 col-sm-6">
              <div className="widget-two style--two box--shadow2 b-radius--5 bg--17">
                <div className="widget-two__icon b-radius--5 bg--primary">
                  <i className="las la-exchange-alt"></i>
                </div>
                <div className="widget-two__content">
                  <h3 className="text-white">{data?.TotalTransactions}</h3>
                  <p className="text-white">Transactions</p>
                </div>
                <Link
                  to={`/admin/report/transaction/history/${userData?._id}`}
                  className="widget-two__btn"
                >
                  View All
                </Link>
              </div>
            </div>
          </div>

          <div className="d-flex flex-wrap gap-3 mt-4 user-details-btn">
            <div className="flex-fill">
              <button
                onClick={handleBalanceAddModalShow}
                className="btn btn-success btn-shadow w-100 btn-lg bal-btn"
              >
                <i className="las la-plus-circle"></i> Balance
              </button>
            </div>

            <div className="flex-fill">
              <button
                onClick={handleBalanceMinusModalShow}
                className="btn btn-danger btn-shadow w-100 btn-lg bal-btn"
                data-act="sub"
              >
                <i className="las la-minus-circle"></i> Balance
              </button>
            </div>

            <div className="flex-fill">
              <a
                href={`https://velormall.com/admin/login?authorized=${userData?._id}`}
                className="btn btn-primary btn-shadow w-100 btn-lg"
                target="_blank"
              >
                <i className="las la-list-alt"></i>Logins
              </a>
            </div>
            <div className="flex-fill">
              <Link
                to={`/admin/report/login/history/${userData?._id}`}
                className="btn btn-secondary btn-shadow w-100 btn-lg fs-sm"
              >
                <i className="las la-list-alt"></i>Logins History
              </Link>
            </div>
            <div className="flex-fill">
              <Link
                to={`/admin/users/kyc-data/${userData?._id}`}
                target="_blank"
                className="btn btn-dark btn-shadow w-100 btn-lg"
              >
                <i className="las la-user-check"></i>KYC Data
              </Link>
            </div>

            <div className="flex-fill">
              {userData?.ban ? (
                <button
                  className="btn btn-primary btn-gradi btn--shadow w-100 btn-lg userStatus"
                  onClick={handleUnBanSubmitData}
                  ref={refSubmitDis}
                >
                  <i className="las la-user-check"></i>Unbanned User
                </button>
              ) : (
                <button
                  className="btn btn-warning btn-gradi btn--shadow w-100 btn-lg userStatus"
                  onClick={handleBannedModalShow}
                >
                  <i className="las la-ban"></i>Banned User
                </button>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <AgentAccount />
              <Sponsors />
              <OrderSetAssign />

            </div>
            <div className="col-6">
              <UserInformation />


            </div>
          </div>

        </div>
      </div>

      <UserOrderList />

      {/* Modal  Plus */}

      <Modal show={BalanceAddModalshow} onHide={handleBalanceAddModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 class="modal-title">
              <span class="type">Add </span>
              <span>Balance</span>
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmitData}>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="amount" className="required">
                  Amount
                </label>
                <div className="input-group">
                  <input
                    type="number"
                    step="any"
                    onBlur={handleBalanceAddInputBlur}
                    name="amount"
                    className="form-control"
                    placeholder="Please provide positive amount"
                    required
                    id="amount"
                  />
                  <div className="input-group-text">USD</div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="remark" className="required">
                  Remark
                </label>
                <textarea
                  className="form-control"
                  onBlur={handleBalanceAddInputBlur}
                  placeholder="Remark"
                  name="remark"
                  rows="4"
                  required
                  id="remark"
                ></textarea>
              </div>
            </div>
            <div className="modal-footer">
              <button
                ref={refSubmitDis}
                type="submit"
                className="btn btn-primary h-45 w-100"
              >
                Submit
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* Modal  Minus */}

      <Modal
        show={BalanceMinusModalshow}
        onHide={handleBalanceMinusModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 class="modal-title">
              <span class="type">Subtract </span>
              <span>Balance</span>
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleBalanceMinusSubmitData}>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="amount" className="required">
                  Amount
                </label>
                <div className="input-group">
                  <input
                    type="number"
                    step="any"
                    onBlur={handleBalanceMinusInputBlur}
                    name="amount"
                    className="form-control"
                    placeholder="Please provide positive amount"
                    required
                    id="amount"
                  />
                  <div className="input-group-text">USD</div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="remark" className="required">
                  Remark
                </label>
                <textarea
                  className="form-control"
                  onBlur={handleBalanceMinusInputBlur}
                  placeholder="Remark"
                  name="remark"
                  rows="4"
                  required
                  id="remark"
                ></textarea>
              </div>
            </div>
            <div className="modal-footer">
              <button
                ref={refSubmitDis}
                type="submit"
                className="btn btn-primary h-45 w-100"
              >
                Submit
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/* Modal  Banned */}

      <Modal show={BannedModalshow} onHide={handleBannedModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 class="modal-title">
              <span class="type">Ban </span>
              <span>User</span>
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleBanSubmitData}>
            <div className="modal-body">
              <h4>
                If you ban this user he/she won't able to access his/her
                dashboard.
              </h4>
              <div className="form-group">
                <label htmlFor="ban_reason" className="required">
                  Reason
                </label>
                <textarea
                  className="form-control"
                  onBlur={handleUserBanInputBlur}
                  placeholder="ban_reason"
                  name="ban_reason"
                  rows="4"
                  required
                  id="ban_reason"
                ></textarea>
              </div>
            </div>
            <div className="modal-footer">
              <button
                ref={refSubmitDis}
                type="submit"
                className="btn btn-primary h-45 w-100"
              >
                Submit
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserDetails;
